import { put, takeEvery } from 'redux-saga/effects';
import { call, select } from 'typed-redux-saga';
import { FetchLoad, ILoad, logisticsActionCreators, LogisticsActionKeys } from '..';
import { IState } from '../..';
import { httpService } from '../../..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { ApiUrls } from '../../ApiUrls';
import { executeApiRequest } from '../../asyncUtils';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { getLoad } from '../logisticsSelectors';

function* fetchLoadSaga(action: FetchLoad) {
  const existingLoad = yield* select((state: IState) => getLoad(state, action.payload.loadNumber));

  if (!existingLoad) {
    yield put(uiActionCreators.showFullPageLoading());
  }
  const response = yield* call(fetchLoad, action.payload.loadNumber);
  yield put(uiActionCreators.hideFullPageLoading());

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(logisticsActionCreators.setLoad(response.value));
  }
}

export function* watchFetchLoad() {
  yield takeEvery(LogisticsActionKeys.FETCH_LOAD, fetchLoadSaga);
}

export async function fetchLoad(loadNumber: string): Promise<IApiExecuteRespone<ILoad | null>> {
  return executeApiRequest(() => httpService.get(ApiUrls.loads({ loadNumber })));
}
